import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileSidebar from "./MobileSidebar";
import logoLight from "../../assets/images/logoLight.svg";
import CartNavLink from "../../components/cart/CartNavLink";
import LanguageSwitcher from "./LanguageSwitcher";
import AppRoutes from "../../routes/AppRoutes";
import { NAV_LINKS } from "../../constants/navigation";
import { scrollToTop } from "../../utils/scroll";
import { isRtlLanguage } from "../../utils/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import "./NavBar.css";

function NavBar(props) {
  const { t, i18n } = useTranslation();
  const ref = useRef();
  const isRtl = isRtlLanguage(i18n.language);

  const toggleMenu = () => {
    if (window.innerWidth >= 1024) return;
    props.setTogol2(!props.togol2);
  };

  const closeMenu = () => {
    props.setTogol2(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        closeMenu();
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      ref={ref}
      id="nav"
      className={isRtl ? "arFont overflow-x-clip" : "enFont overflow-x-clip"}
    >
      <button
        type="button"
        id="nav2"
        onClick={closeMenu}
        className={`mobile-nav-overlay lg:hidden ${props.togol2 ? "visible" : "hidden"}`}
        aria-hidden={!props.togol2}
        aria-label={t("Close")}
      />
      <MobileSidebar
        isOpen={props.togol2}
        onToggle={props.setTogol2}
        onLanguageChange={closeMenu}
      />
      <header className="caf-site-nav" dir={isRtl ? "rtl" : "ltr"}>
        <div className="caf-site-nav__inner">
          <NavLink
            to="/"
            onClick={scrollToTop}
            className="caf-site-nav__brand"
            aria-label={t("Home")}
          >
            <img src={logoLight} alt="CAF Sports" className="caf-site-nav__logo" />
          </NavLink>

          <nav className="caf-site-nav__menu hidden lg:block" aria-label="Main">
            <ul className="caf-site-nav__links">
              {NAV_LINKS.map(({ to, labelKey }) => (
                <li key={to}>
                  <NavLink
                    onClick={scrollToTop}
                    className={({ isActive }) =>
                      `caf-site-nav__link${isActive ? " is-active" : ""}`
                    }
                    to={to}
                  >
                    {t(labelKey)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          <div className="caf-site-nav__actions">
            <div className="hidden items-center gap-2 lg:flex">
              <CartNavLink />
              <LanguageSwitcher onLanguageChange={closeMenu} />
            </div>
            <div className="flex items-center gap-2 lg:hidden">
              <CartNavLink className="caf-cart-nav--mobile" />
              <LanguageSwitcher compact onLanguageChange={closeMenu} />
              <button
                type="button"
                onClick={toggleMenu}
                className="caf-site-nav__menu-btn"
                aria-label="Menu"
                aria-expanded={props.togol2}
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
            </div>
          </div>
        </div>
      </header>
      <AppRoutes />
    </div>
  );
}

export default NavBar;
